export default __webpack_public_path__ + "static/media/listimg.3ca87512.png";